export function pushToDataLayer(event: any) {
  if ((window as any)?.dataLayer) {
    try {
      (window as any).dataLayer.push(event);
    } catch (error) {
      console.error('Error pushing event to dataLayer:', error);
    }
  }
}
